/* eslint-disable react/prop-types */
import React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import VideoJSPlayer from "./VideoJSPlayer/VideoJSPlayer";
// import thumbnail from "../../../assets/thumbnil.png";

const VideoRenderer = ({ videoSource }) => {
	const playerRef = React.useRef(null);

	const videoJsOptions = {
		autoplay: true,
		controls: true,
		responsive: true,
		fluid: true,
		loop: true, // Add this line to enable loop
		sources: [
			{
				src: videoSource,
				type: "video/mp4"
			}
		]
	};

	// eslint-disable-next-line arrow-parens
	const handlePlayerReady = (player) => {
		playerRef.current = player;

		// You can handle player events here, for example:
		player.on("waiting", () => {
			videojs.log("player is waiting");
		});

		player.on("dispose", () => {
			videojs.log("player will dispose");
		});
	};

	return <VideoJSPlayer options={videoJsOptions} onReady={handlePlayerReady} />;
};

export default VideoRenderer;
